import {m, Control} from '../../n2/components/base.js'

export const TopBar = {
    view: (vnode) =>
        m('.w-full.bg-white.bg-opacity-95.backdrop-blur-md.border-b.border-slate-200.shadow-sm.z-20', [
            m('.w-full.px-4.py-2.5.flex.flex-row.items-center.justify-between.space-x-4', [
                m('.flex.flex-row.items-center.space-x-3.flex-shrink-0', [
                    m('img.h-8.w-auto', {src: '/assets/logo-left.svg', alt: 'Logo'}),
                    (vnode.attrs.title || vnode.attrs.subTitle) && m('.h-5.w-px.bg-slate-200'),
                    m('div.flex.flex-row.items-baseline.text-base.lg:text-lg.tracking-tight.whitespace-nowrap.flex-shrink-0', [
                        vnode.attrs.title && m('span.font-bold.text-slate-800.mr-1.5', ((vnode.attrs.title || '')).toUpperCase()),
                        vnode.attrs.subTitle && m('span.font-extrabold.text-brand1', (vnode.attrs.subTitle || '').toUpperCase())
                    ])
                ]),
                m('.flex.flex-row.items-center.space-x-2.flex-grow.justify-center.overflow-x-auto.no-scrollbar',
                    vnode.children.slice(0, 1)
                ),
                m('.flex.flex-row.items-center.space-x-2.flex-shrink-0',
                    vnode.children.slice(1)
                )
            ]),
            m('.w-full.h-0.5.bg-gradient-to-r.from-brand1.via-amber-400.to-slate-200')
        ])
}

export const BottomBar = {
    view: () => m('.w-full.h-1.bg-gradient-to-r.from-brand1.via-brand1-light.to-orange-400')
}

export class BasicFrame extends Control {
    constructor(vnode) {
        super(vnode, '.flex.flex-col.h-screen.w-full.overflow-hidden.bg-slate-50.text-slate-800')
    }

    getBackgroundSrc() {
        return this.attrs.backgroundSrc
    }

    getTitle() {
        return this.attrs.title
    }

    getSubTitle() {
        return this.attrs.subTitle
    }

    renderBodySections() {
        return this.vnode.children
    }

    renderBody() {
        const leftBar = this.renderLeftBar()
        const rightBar = this.renderRightBar()
        return m('.w-full.flex-grow.relative.overflow-hidden', [
            m('.absolute.inset-0.flex.flex-col.items-center.justify-start.overflow-auto.p-4.md:p-8',
                this.renderBodySections()
            ),
            leftBar && m('.absolute.left-0.top-0.bottom-0.z-10', leftBar),
            rightBar && m('.absolute.right-0.top-0.bottom-0.z-10', rightBar),
            m('.pointer-events-none.absolute.left-0.w-full.shadow-lg', { style: { height: '50px', top: '-50px' } }),
        ])
    }

    renderTopBarComponents() {
        return []
    }

    renderLeftBar()  { return undefined }

    renderRightBar() { return undefined }

    renderChildren() {
        return [
            m(TopBar, {
                title: this.getTitle(),
                subTitle: this.getSubTitle()
            }, this.renderTopBarComponents()),
            this.renderBody(),
            m(BottomBar)
        ]
    }

    getAttributes() {
        const backgroundSrc = this.getBackgroundSrc()
        return Object.assign(super.getAttributes(), {
            style: backgroundSrc && {
                backgroundImage: 'url("' + backgroundSrc + '")',
                backgroundPosition: 'center bottom',
                backgroundSize: 'cover'
            }
        })
    }
}